import {
	computed,
	DestroyRef,
	Directive,
	DoCheck,
	EmbeddedViewRef,
	Host,
	inject,
	input,
	Input,
	OnDestroy,
	OnInit,
	Optional,
	SkipSelf,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { AbstractScreen } from '../components/abstract-screen.js'
import { FrontendLanguageBridge } from '../bridges/frontend-language-bridge.js'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { DevBarService } from '../services/dev-bar.service.js'
import { FormDirective } from './form.directive.js'

@Directive({
	selector: '[formControl]',
	standalone: false,
})
export class FormControlDestroyDirective {
	formControl = input<FormControl>()
	private destroyRef = inject(DestroyRef)
	private formDirective = inject(FormDirective, { optional: true })

	constructor() {
		this.destroyRef.onDestroy(() => {
			const formControl = this.formControl()
			if (formControl) {
				this.formDirective?.unregisterFormControl(formControl)
			}
		})
	}
}
